import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers/combineReducers';
import { googleAnalytics } from './configs/react-ga-config';

export default function configureStore() {
  return createStore(
    rootReducer,
    compose(
      applyMiddleware(
        thunkMiddleware
      ),
      applyMiddleware(
        googleAnalytics
      )
    )

  )
}


// WEBPACK FOOTER //
// ./src/configureStore.js